var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M5.594 12.327V5.552c0-.267.08-.527.226-.747L7.64 2.1c.287-.434 1-.74 1.607-.514.653.22 1.087.954.947 1.607l-.347 2.18c-.027.2.027.38.14.52a.62.62 0 0 0 .46.207h2.74c.527 0 .98.213 1.247.586.253.36.3.827.133 1.3l-1.64 4.994c-.207.826-1.107 1.5-2 1.5h-2.6c-.447 0-1.073-.154-1.36-.44l-.853-.66a1.32 1.32 0 0 1-.52-1.054M3.474 4.253h-.687c-1.033 0-1.453.4-1.453 1.387v6.706c0 .987.42 1.387 1.453 1.387h.687c1.033 0 1.453-.4 1.453-1.387V5.64c0-.987-.42-1.387-1.453-1.387"
  })));
};
export { SvgLike as ReactComponent };